import { render, staticRenderFns } from "./DummyPage.vue?vue&type=template&id=6aa3f87f"
import script from "./DummyPage.vue?vue&type=script&lang=js"
export * from "./DummyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports